"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CFConfig = void 0;
exports.CFConfig = {
    name: "CF",
    fontSize: "14px",
    textColor: "#354154",
    bgColor: "#FFF",
    variantColors: {
        primary: { text: "#26A5B8", bg: "bgColor" },
        secondary: { text: "#DD0076", bg: "bgColor" },
        tertiary: { text: "#F9B122", bg: "textColor" },
        quaternary: { text: "#8F9EB5", bg: "bgColor" },
        disabled: { text: "#AEBACD", bg: "bgColor" },
        success: { text: "#429F65", bg: "bgColor" },
        warning: { text: "#F9B122", bg: "bgColor" },
        error: { text: "#E55701", bg: "bgColor" },
    },
};
//# sourceMappingURL=cf.js.map